const actions = {
  SET_STATE: 'user/SET_STATE',
  RESET_PASSWORD: 'user/RESET_PASSWORD',
  LOGIN: 'user/LOGIN',
  LOGIN_WITH_GOOGLE: 'user/LOGIN_WITH_GOOGLE',
  // REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
}

export default actions
